import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
// import { useLocation } from 'react-router-dom';
// import { getLanguage } from '../../../utils/params';
// import { LazyLoadImage } from 'react-lazy-load-image-component';
import { useTranslation } from 'react-i18next';

const PolicyContent = props => {
    //   const language = getLanguage(useLocation());
    const { t } = useTranslation();
    return (
        <div className="row">
            {props.content ? (
                <div className="col-12">
                    <div className="rating-form box-white">
                        <div className="row">
                            <div className="col-12 d-flex justify-content-between">
                                <div className="">
                                    <h1 className="policy-title text-uppercase">{props.content.title}</h1>
                                    <p className="policy-date mt-2">{t('search_property.latest_update') + props.content.publicDate}</p>
                                </div>
                                <div className="">
                                    <img alt="icon-policy" src={`${process.env.REACT_APP_ISN_IMAGE_URL}${props.content.iconUrl}`} />
                                </div>
                            </div>
                            <div className="col-12 mt-2">
                                <div dangerouslySetInnerHTML={{ __html: props.content.content }} />
                            </div>
                        </div>
                    </div>
                </div>)
                : ''}
        </div>
    );
};

const mapStateToProps = state => ({
    ...state,
});

const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(PolicyContent);
